module.exports = __webpack_public_path__ + "static/media/trabalhos.0c43bd3e.svg";